import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { config } from './../config';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LabourJobService {
  linkedAssets = []
  private assetCategory = new Subject()
  // listofAssetcategory = this.assetCategory.asObservable()

  constructor(
    private http: HttpClient
  ) { }

  listofAssetcategory(): Observable<any> {
    return this.assetCategory.asObservable()
  }

  // Create new labour job with required data

  createLabourjob(data: any): Observable<any> {
    console.log('Adding Jobs', data)
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "labourjob", data).subscribe((res: any) => {
        console.log("response of new job created", res);
        observer.next(res.data);
        observer.complete();
      }, err => {
        console.log("ERROR");
        observer.error(err.msg);
      }, () => {
        observer.complete()
      })
    })
  }

  editLabourjob(data: any, id) {
    console.log("Edit jobs------", data, id);
    Object.assign(data, { _id: id })
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "labourjob", data).subscribe((res: any) => {
        console.log("Edited job : ", res);
        observer.next(res.data);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });

  }


  deleteLabourjob(jobList) {
    return new Observable((observer) => {
      this.http.delete(config.baseApiUrl + "labourjob?_job=" + jobList).subscribe((res: any) => {
        observer.next(res);
        observer.complete();
      })
    })
  }


  // Get all labour job list

  getLabourjoblist(): Observable<any> {
    console.log("Getting jobs");
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "labourjob").subscribe((res: any) => {
        console.log("Get Jobs... :11111111 ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  getLabourjoblistbyClient(clientId): Observable<any> {
    console.log("Getting jobs");
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "labourjob/client?_id=" + clientId).subscribe((res: any) => {
        console.log("Get Jobs... :11111111 ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }



  // Get single labour job details
  getSingleLabourjob(jobId): Observable<any> {
    console.log("Getting jobs", jobId);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "labourjob?_id=" + jobId).subscribe((response: any) => {
        console.log("Get Jobs... : ", response.data);
        // this.getJob.next(response.data[0])
        observer.next(response.data);
        observer.complete();
      })
    });
  }

  // Get Staff Dairy data for labour job
  getPlannerData(data): Observable<any> {
    console.log("data of get display table", data);
    return new Observable<any>((observer) => {
      this.http.put(config.baseApiUrl + "labourjob/schedular", data).subscribe((res: any) => {
        console.log("response of instructores list", res);
        observer.next(res.data)
        observer.complete()
      })
    })
  }


  // Remove users from labour job
  removeUsers(data): Observable<any> {
    console.log("data of get display table", data);
    return new Observable<any>((observer) => {
      this.http.put(config.baseApiUrl + "labourjob/removeuser", data).subscribe((res: any) => {
        console.log("response of instructores list", res);
        observer.next(res.data)
        observer.complete()
      })
    })
  }


  // Add signature of client and operative in single labour job
  addJobSignature(data): Observable<any> {
    console.log("data of get display table", data);
    return new Observable<any>((observer) => {
      this.http.put(config.baseApiUrl + "labourjob/add-signature", data).subscribe((res: any) => {
        console.log("response of instructores list", res);
        observer.next(res.data)
        observer.complete()
      })
    })
  }

  downloadTimesheet(data): Observable<any> {
    console.log("data of get display table", data);
    return new Observable<any>((observer) => {
      this.http.put(config.baseApiUrl + "labourjob/download-time-sheet", data).subscribe((res: any) => {
        console.log("response of instructores list", res);
        observer.next(res.data)
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete()
      })
    })
  }

  generateJobPrint(data): Observable<any> {
    console.log("data of get display table", data);
    return new Observable<any>((observer) => {
      this.http.put(config.baseApiUrl + "labourjob/download-job", data).subscribe((res: any) => {
        console.log("response of instructores list", res);
        observer.next(res.data)
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete()
      })
    })
  }


  addmultipleUserslogs(data, jobId = null): Observable<any> {
    console.log("data of get display table", data);
    return new Observable<any>((observer) => {
      this.http.put(config.baseApiUrl + "labourjob/add-multiple-logs?jobId=" + jobId, data).subscribe((res: any) => {
        console.log("response of instructores list", res);
        observer.next(res.data)
        observer.complete()
      })
    })
  }


  // Duplicate basic details of job and create new job
  duplicateJob(jobId): Observable<any> {
    console.log("Getting jobs", jobId);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "labourjob/clone?jobId=" + jobId).subscribe((response: any) => {
        console.log("Get Jobs... : ", response.data);
        // this.getJob.next(response.data[0])
        observer.next(response.data);
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }

  // Asset unlinked with asset
  unlinkedAsset(data): Observable<any> {
    console.log("Getting jobs", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.put(config.baseApiUrl + "labourjob/unallocate-asset", data).subscribe((response: any) => {
        console.log("Get Jobs... : ", response.data);
        // this.getJob.next(response.data[0])
        observer.next(response);
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }

  getRequiredjobData(test): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("HOW MANY TIME IT IS CALL", test);
      this.http.get(config.baseApiUrl + "labourjob/other-modal-details").subscribe((response: any) => {
        console.log("Get Jobs... : ", response.data);
        // this.getJob.next(response.data[0])
        observer.next(response.data);
        this.assetCategory.next(response.data.assetList)
      }, (error) => {
        observer.error(error)
      }, () => {
        observer.complete();
      })
    });
  }


  addRemarkinJob(remarkData): Observable<any> {
    console.log('Adding Jobs', remarkData)
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "labourjob/remark", remarkData).subscribe((res: any) => {
        console.log("response of new job created", res);
        observer.next(res.data);
      }, err => {
        console.log("ERROR");
        observer.error(err.msg);
      }, () => {
        observer.complete()
      })
    })
  }

  // Get job list from staffId
  getJobByStaffId(instructorId): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "labourjob/job-list?_id=" + instructorId).subscribe((res: any) => {
        console.log("Get Jobs... : Of Single Staff ", res);
        observer.next(res);
      }, err => {
        observer.error(err)
      }, () => {
        observer.complete();
      })
    });
  }


  /**
     * @param data timelog array selected by operative user.
     * @returns timelog with status 'submitted'
     * This function will update the status of timelog from draft to submitted.
     */
  submitTimelogForApproval(data, isLabourjob: boolean): Observable<any> {
    console.log("data of get display table", data);
    return new Observable<any>((observer) => {
      this.http.put(config.baseApiUrl + "user-timelog/update-status?isLabourjob=" + isLabourjob, data).subscribe((res: any) => {
        console.log("response of instructores list", res);
        observer.next(res.data);
      }, error => {
        observer.error(error)
      }, () => {

        observer.complete();
      });
    });
  }


  getTimesheetFilterList(): Observable<any> {
    return new Observable<any>((observer) => {
      this.http
        .get(config.baseApiUrl + "labourjob/timesheet-filter-list")
        .subscribe(
          (response: any) => {
            observer.next(response);
          },
          (error) => {
            observer.error(error);
          },
          () => {
            observer.complete();
          }
        );
    });
  }

  /**
   * @param data date array.
   * @returns list of labourjob with timelogs for Timesheet Approval.
   */
  getJobsForApproval(data: any): Observable<any> {
    console.log('API called : ', data);
    return new Observable<any>((observer) => {
      this.http
        .post(config.baseApiUrl + "user-timelog/get-approval-jobs", data)
        .subscribe(
          (response: any) => {
            // this.getJob.next(response.data[0])
            observer.next(response);
          },
          (error) => {
            observer.error(error);
          },
          () => {
            observer.complete();
          }
        );
    });
  }

  

}
